class AnimatedLogo extends HTMLElement {
  connectedCallback() {
    this._played = false;
    this._timeouts = [];
    this._mask = this.querySelector('[data-animated-logo-mask]');
    this._markWrap = this.querySelector('.animated-logo__mark-wrap');
    this._pen = this.querySelector('[data-animated-logo-pen]');
    this._ring = this.querySelector('[data-animated-logo-ring]');
    this._glow = this.querySelector('[data-animated-logo-glow]');
    this._tagline = this.querySelector('[data-animated-logo-tagline]');
    this._subtext = this.querySelector('[data-animated-logo-subtext]');

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    const animationsEnabled = document.body.classList.contains(
      'waka-animate',
    );

    if (reducedMotion || !animationsEnabled || !('IntersectionObserver' in window)) {
      this._play(true);
      return;
    }

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this._play(false);
          this._observer.disconnect();
        });
      },
      { threshold: 0.35 },
    );
    this._observer.observe(this);
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
    this._timeouts.forEach((id) => clearTimeout(id));
  }

  _schedule(fn, delay, instant) {
    if (instant) {
      fn();
      return;
    }
    this._timeouts.push(setTimeout(fn, delay));
  }

  _play(instant) {
    if (this._played) return;
    this._played = true;

    const motion = this.dataset.motion === 'fade' ? 'fade' : 'write';
    const duration = instant ? 0 : motion === 'write' ? 1900 : 900;

    if (this._glow) this._glow.style.opacity = '1';

    if (this._mask) {
      if (motion === 'write') {
        this._mask.style.animationDuration = `${duration}ms`;
        this._mask.classList.add('animated-logo__mask--write');
      } else {
        this._mask.style.clipPath = 'inset(0 0 0 0)';
        this._mask.style.animationDuration = `${duration}ms`;
        this._mask.classList.add('animated-logo__mask--fade');
      }
    }

    if (this._pen && motion === 'write') {
      this._pen.style.animationDuration = `${duration}ms`;
      this._pen.classList.add('animated-logo__pen--play');
    }

    this._schedule(
      () => {
        if (this._ring) {
          this._ring.classList.add('animated-logo__ring--play');
          this._schedule(
            () => this._ring.classList.add('animated-logo__ring--fade'),
            2400,
            instant,
          );
          this._schedule(
            () => this._ring.classList.add('animated-logo__ring--done'),
            3200,
            instant,
          );
        }
        if (this._markWrap) this._markWrap.classList.add('animated-logo__mark-wrap--float');
      },
      duration + 60,
      instant,
    );

    this._schedule(
      () => {
        if (this._tagline) this._tagline.classList.add('is-visible');
      },
      duration + 260,
      instant,
    );

    this._schedule(
      () => {
        if (this._subtext) this._subtext.classList.add('is-visible');
      },
      duration + 480,
      instant,
    );
  }
}

if (!customElements.get('animated-logo')) {
  customElements.define('animated-logo', AnimatedLogo);
}
